import { getDefaultAsyncWrapperObj, AsyncRequestStatus } from '@ane/core/lib/models';
export const defaultReducerState = {
    access: getDefaultAsyncWrapperObj(),
};
// Action Types
const actionTypesPrefix = 'loadDataSourceAccess';
export const dataSourceAccessActionTypes = {
    LOAD: `${actionTypesPrefix}/LOAD`,
    LOADING: `${actionTypesPrefix}/LOADING`,
    LOADED: `${actionTypesPrefix}/LOADOADED`,
};
// Action Creators
export const dataSourceAccessLoadAction = (workspaceId, dataSourceName) => {
    return {
        type: dataSourceAccessActionTypes.LOAD,
        payload: { workspaceId: workspaceId, dataSourceName: dataSourceName },
    };
};
export const dataSourceAccessLoadingAction = (payload) => {
    return {
        type: dataSourceAccessActionTypes.LOADING,
        payload: payload,
    };
};
export const dataSourceAccessLoadedAction = (payload, result) => {
    return {
        type: dataSourceAccessActionTypes.LOADED,
        payload: {
            access: result,
        },
    };
};
// Reducer
export const reducer = (state = defaultReducerState, action) => {
    switch (action.type) {
        case dataSourceAccessActionTypes.LOADING:
            return {
                ...state,
                access: {
                    ...state.access,
                    status: AsyncRequestStatus.Pending,
                },
            };
        case dataSourceAccessActionTypes.LOADED:
            const loadedAction = action;
            return {
                ...state,
                access: loadedAction.payload.access,
            };
        default:
            return state;
    }
};
export default reducer;

//# sourceMappingURL=DataSourceAccess.ducks.js.map
